<template>
  <i-dx-popup
    :popupVisible="popupVisible"
    :title="title"
    @popupCloseButtonClick="closeBtn"
    :height="'100vh'"
    width="80vw"
  >
    <template v-slot:grid>
      <div class="v-application" style="display: block !important;">
        <v-row no-gutters class="px-6">
          <v-col cols="4" class="pr-2 d-flex flex-column" height="100%">
            <v-card width="100%" color="inner_card_bg" flat class="py-3 px-4 rounded">
              <div class="card-sub-title">현재 적용된 양식</div>
              <div class="card-title">{{ applyDataDiv.dataDivNm }}</div>
              <div class="card-title-code">({{ applyDataDiv.dataDiv }})</div>
            </v-card>
            <v-card
              color="inner_card_bg"
              flat
              height="calc(100vh - 268px)"
              class="pa-4 mt-2 rounded overflow-y-auto"
            >
              <v-list class="popup-card-list">
                <v-list-item-group v-model="selectedIndex" mandatory color="primary">
                  <v-list-item
                    v-for="(item, index) in dataSource"
                    :key="index"
                    :class="{ selected: index === selectedIndex }"
                    outlined
                  >
                    <v-list-item-content @click="handleItemClick(item)">
                      <v-text-field
                        v-model="item.dataDivNm"
                        :rules="rules"
                        dense
                        hide-details="auto"
                        solo
                        spellcheck="false"
                        placeholder="양식명을 입력하세요."
                        :disabled="item.clntId === 'COMMON'"
                        @change="dataDivNmChanged($event, item)"
                      />
                      <v-list-item-subtitle>{{ item.dataDiv }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="ml-2">
                      <v-btn
                        color="primary"
                        elevation="0"
                        small
                        outlined
                        height="30px"
                        class="rounded"
                        :disabled="(item.clntId != 'COMMON' && item.finalUse == 'Y') || (item.clntId == 'COMMON' && basicApplyFlag)"
                        @click="btnDivApply(item)"
                      >
                        <span>
                          {{
                          (item.clntId != 'COMMON' && item.finalUse == 'Y') || (item.clntId == 'COMMON' && basicApplyFlag) ? '적용중' : '적용'
                          }}
                        </span>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
            <div class="btn-wrap mt-2">
              <v-btn
                color="error"
                elevation="0"
                large
                outlined
                class="rounded"
                :disabled="selectedDiv.clntId === 'COMMON' || selectedDiv.finalUse === 'Y'"
                @click="btnDivDelete()"
              >
                <span>삭제</span>
              </v-btn>
              <v-btn
                color="primary"
                elevation="0"
                large
                outlined
                class="rounded"
                @click="btnDivAdd()"
              >
                <span>추가</span>
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <!-- <v-icon small color="primary" style="position: absolute; right: 5px;" v-on="on">mdi-information-outline</v-icon> -->
                    <svg-icon
                      icon-class="info"
                      style="height: 1rem; position: absolute; right: 5px;"
                      v-on="on"
                    />
                  </template>
                  <div class="tooltip-text">{{ '빈 양식을 생성하여 사용자가 항목을 설정합니다.' }}</div>
                </v-tooltip>
              </v-btn>
              <v-btn
                color="primary"
                elevation="0"
                large
                outlined
                class="rounded"
                :disabled="!selectedDiv"
                @click="btnDivCopy()"
              >
                <span>복사</span>
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <!-- <v-icon small color="primary" style="position: absolute; right: 5px;" v-on="on">mdi-information-outline</v-icon> -->
                    <svg-icon
                      icon-class="info"
                      style="height: 1rem; position: absolute; right: 5px;"
                      v-on="on"
                    />
                  </template>
                  <div class="tooltip-text">{{ '현재 선택된 양식을 복사하여 추가/수정/삭제하여 사용합니다.' }}</div>
                </v-tooltip>
              </v-btn>
              <v-btn
                color="primary"
                elevation="0"
                large
                outlined
                class="rounded"
                :disabled="selectedDiv.clntId === 'COMMON'"
                @click="btnDivSave()"
              >
                <span>저장</span>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="8" class="pl-2">
            <i-card-vertical
              headerTitle="안전점검 항목 목록"
              device="web"
              :IsUseInnerAddition="true"
              :onlyGrid="true"
              contentsClass="popup-grid-card"
            >
              <template v-slot:innerAddition>
                <div class="btn-wrap ml-2">
                  <v-btn
                    color="error"
                    elevation="0"
                    large
                    outlined
                    class="rounded"
                    :disabled="selectedDiv.clntId === 'COMMON'"
                    @click="btnListDelete()"
                  >
                    <span>삭제</span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    elevation="0"
                    large
                    outlined
                    class="rounded"
                    :disabled="selectedDiv.clntId === 'COMMON'"
                    @click="btnListAdd()"
                  >
                    <span>추가</span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    elevation="0"
                    large
                    outlined
                    class="rounded"
                    :disabled="selectedDiv.clntId === 'COMMON'"
                    @click="btnListSave()"
                  >
                    <span>저장</span>
                  </v-btn>
                </div>
              </template>
              <template v-slot:body>
                <DxDataGrid
                  key-expr="seq"
                  height="calc(100vh - 180px)"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="false"
                  :show-borders="true"
                  :show-row-lines="true"
                  :focused-row-enabled="true"
                  :hoverStateEnabled="true"
                  @focused-row-changed="onFocusedRowChanged"
                  @editing-start="onEditingStart"
                  @editor-preparing="onEditorPreparing"
                >
                  <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />
                  <DxSelection
                    select-all-mode="allPages"
                    show-check-boxes-mode="always"
                    mode="multiple"
                  />
                  <!-- 컬럼 정의 -->
                  <DxColumn
                    data-field="seq"
                    data-type="string"
                    alignment="center"
                    caption="번호"
                    :allow-editing="false"
                    width="50px"
                  />
                  <DxColumn
                    data-field="safetyInspectionDailyDivItemNm"
                    data-type="string"
                    caption="안전점검 항목"
                    :allow-editing="true"
                  />
                </DxDataGrid>
              </template>
            </i-card-vertical>
          </v-col>
        </v-row>
      </div>
    </template>
  </i-dx-popup>
</template>

<script>
import IDxPopup from '@/components/common/iDxPopup.vue'
import { DxList } from 'devextreme-vue/list'
import { DxTreeView } from 'devextreme-vue/tree-view'
import { getCommonCode } from '@/api/common/commonApi'
import { getGrpAuth } from '@/api/common/commonApi'
import { getHrGroup } from '@/api/component/component'
import { getUserListInfo } from '@/api/system/userManage'
// 일일점검 조회,저장,삭제 Api
import {
  getSafetyInspectionItemList,
  saveSafetyInspectionItem,
  saveSafetyInspectionItemList,
  deleteSafetyInspectionItem,
  deleteSafetyInspectionItemList
} from '@/api/riskAssessment/safetyInspectionManage'

import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    IDxPopup
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => ''
    },
    itemList: {
      type: Array,
      default: () => []
    },
    compId: {
      type: String,
      default: () => ''
    },
    rowLevel: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      componentKey: 0,
      rules: [
        value => {
          if (value) return true
          return '필수입력 값입니다.'
        }
      ],
      dataSource: [],
      saveDataDivList: [],
      applyDataDiv: {},
      myEsgHrNo: '',
      selectedDiv: {}, // 선택된 항목의 인덱스를 저장하는 변수
      selectedIndex: 0,
      gridMain: [],
      treeView: 'treeview',
      dxDataGridRef: 'datagrid',
      hrGroups: [],
      hrTree: [],
      jbrpList: [],
      grpAuthList: [],
      path: '',
      copySelectedHrs: [],
      selectedHrs: [],
      safetyList: [],
      selectedItemId: '',
      focusedRow: null
    }
  },
  computed: {
    // 기본항목 적용/적용중 플래그값 생성
    basicApplyFlag: function() {
      let flag = true
      let data = this.dataSource.filter(el => el.finalUse === 'Y' && el.clntId != 'COMMON')
      if (data.length > 0) flag = false
      return flag
    }
  },
  watch: {
    popupVisible() {
      if (this.popupVisible) {
        this.dataSource = _.clone(this.itemList)
        if (this.dataSource.length === 1) this.selectedDiv = this.dataSource[0]
        else {
          this.selectedDiv = this.dataSource.find(el => el.clntId !== 'COMMON' && el.finalUse === 'Y')
          if (!this.selectedDiv) {
            this.selectedDiv = this.dataSource.find(el => el.finalUse === 'Y')
          }
        }
        if (Object.keys(this.applyDataDiv)) this.applyDataDiv = _.clone(this.selectedDiv)
        this.selectedIndex = this.dataSource.findIndex(el => el.dataDiv === this.selectedDiv.dataDiv)
        console.log('######################## this.selectedDiv', this.selectedDiv.seq)
      }
    },
    selectedDiv() {
      if (Object.keys(this.selectedDiv).length > 0) {
        console.log('#### this.selectedDiv', this.selectedDiv, this.dataSource)
        this.selectedDiv.writeDt = this.selectedDiv.dataDiv.substring(0, 8)
        this.btnSearch(this.selectedDiv)
      }
    }
  },
  created() {},
  mounted() {
    getUserListInfo({ clntId: this.getClntId(), userCd: this.getUserCd() }).then(res => {
      console.log('##res ==> ', res)
      if (res.success && res.list.length > 0) {
        this.myEsgHrNo = res.list[0].esgHrNo
      }
    })
  },
  methods: {
    getCurrentDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}${month}${day}`
    },
    async btnSearch(params) {
      // this.gridMain = []
      this.openLoading()
      console.log('this.params', params)

      await getSafetyInspectionItemList(params, true)
        .then(res => {
          if (res.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.gridMain = _.clone(res.list)
            this.endLoading()
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          }
        })
        .catch(e => {
          this.endLoading()
        })
        .finally(() => {})
    },
    /************************** ************ **************************/
    /************************** 양식목록 버튼 **************************/
    /************************** ************ **************************/
    async btnDivAdd() {
      const currentDate = this.getCurrentDate()
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeDt: currentDate,
        dataDivNm: `${currentDate.substring(0, 4)}년 ${currentDate.substring(4, 6)}월 ${currentDate.substring(6, 8)}일 일일 안전점검 양식`,
        finalUse: 'N',
        itemList: [],
        __created__: true
      }
      await saveSafetyInspectionItem(params, true).then(res => {
        console.log('##Res', res)
        params.dataDiv = res.map.dataDiv
        this.dataSource.splice(1, 0, params)
        this.selectedDiv = this.dataSource.find(el => el.dataDiv === params.dataDiv)
      })
    },
    async btnDivCopy() {
      const currentDate = this.getCurrentDate()
      this.gridMain.forEach(el => {
        el.clntId = this.getClntId()
        el.compId = this.getCompId()
        ;(el.__created__ = true), (el.__deleted__ = false)
      })
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeDt: currentDate,
        dataDivNm: `${this.selectedDiv.dataDivNm}(복사본)`,
        finalUse: 'N',
        itemList: this.gridMain
      }
      await saveSafetyInspectionItem(params, true).then(res => {
        params.dataDiv = res.map.dataDiv
        this.gridMain.forEach(el => {
          el.dataDiv = res.dataDiv
        })
        this.dataSource.splice(1, 0, params)
        this.selectedDiv = this.dataSource.find(el => el.dataDiv === params.dataDiv)
      })
    },
    async btnDivSave() {
      if (this.saveDataDivList.length == 0) {
        this.vSnackbar(this.$t('수정된 항목이 없거나, 저장할 데이터가 없습니다.'), 'warn')
        return
      }
      this.vToastifyPrompt(this.$t('doSaveData'), 'info', current => {
        this.openLoading()
        this.saveDataDivList.forEach(el => {
          if (el.dataDiv === this.applyDataDiv.dataDiv) this.applyDataDiv.dataDivNm = el.dataDivNm
          saveSafetyInspectionItem(el, true)
            .then(res => {
              if (res.success) {
                //
              }
            })
            .catch(error => {
              this.endLoading()
            })
            .finally(() => {})
        })
        this.endLoading()
      })
    },
    btnDivDelete() {
      if (this.selectedDiv.clntId === 'COMMON') {
        this.vSnackbar(this.$t('기본데이터는 삭제할 수 없습니다.'), 'warn')
        return
      }
      this.selectedDiv.esgHrNo = this.myEsgHrNo
      this.selectedDiv.itemList = this.gridMain
      console.log('### 삭제할 항목 --> ', this.selectedDiv)

      this.vToastifyPrompt(this.$t('항목을 삭제하시면 항목목록이 전부 삭제됩니다. 진행하시겠습니까?'), 'warn', current => {
        // 선택된 항목을 배열에서 제거합니다.
        this.openLoading()
        deleteSafetyInspectionItem(this.selectedDiv, true)
          .then(res => {
            //

            this.dataSource = this.dataSource.filter(el => el.dataDiv != this.selectedDiv.dataDiv)
            this.selectedDiv = this.dataSource.length === 1 ? this.dataSource[0] : this.dataSource[1]
            // this.dataSource.find(el=> el.dataDiv === this.selectedDiv.dataDiv).finalUse = 'Y'
          })
          .catch(e => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
            this.dataSource.length === 1 ? this.btnSearch(this.dataSource[0]) : this.btnSearch(this.dataSource[1])
          })
      })
    },
    btnDivApply(item) {
      this.closeVSnackbar()
      if (item.finalUse === 'Y' && item.clntId !== 'COMMON') {
        this.vSnackbar(this.$t('이미 적용중인 양식입니다.'), 'warn')
        return
      }
      console.log('###### item', item)
      this.vToastifyPrompt(
        this.$t('선택한 항목을 적용하시겠습니까?'),
        'info',
        current => {
          // this.selectedDiv = item
          // this.applyDataDiv = _.clone(this.selectedDiv)
          item.__updated__ = true
          item.finalUse = 'Y'

          this.applyDataDiv.__updated__ = true
          this.applyDataDiv.finalUse = 'N'
          this.openLoading()
          saveSafetyInspectionItem(item, false).then(res => {
            if (res.success && this.applyDataDiv.clntId !== 'COMMON') {
              saveSafetyInspectionItem(this.applyDataDiv, true)
                .then(res => {
                  if (res.success) {
                    item.__updated__ = false
                    let beforeDataIndex = this.dataSource.findIndex(el => el.dataDiv === this.applyDataDiv.dataDiv)
                    this.dataSource[beforeDataIndex].finalUse = 'N'
                    this.dataSource[beforeDataIndex].__updated__ = false
                    console.log('#################', this.saveDataDivList)
                    // 양식이름 변경에 따라 저장된 저장소 값 세팅
                    this.saveDataDivList.find(el => el.dataDiv === item.dataDiv).finalUse = item.finalUse
                    this.saveDataDivList.find(el => el.dataDiv === this.dataSource[beforeDataIndex].dataDiv).finalUse = this.dataSource[
                      beforeDataIndex
                    ].finalUse
                  }
                })
                .catch(error => {
                  this.endLoading()
                })
                .finally(() => {
                  this.selectedDiv = item
                  this.applyDataDiv = _.clone(this.selectedDiv)
                  this.endLoading()
                })
            } else {
              this.selectedDiv = item
              this.applyDataDiv = _.clone(this.selectedDiv)
              this.endLoading()
            }
          })

          console.log('#####', item, this.selectedDiv)
          // let selected = this.copySelectedHrs
          // this.$emit('apply', selected)
        },
        null,
        true
      )
    },
    /************************** ************ **************************/
    /************************** 항목목록 버튼 **************************/
    /************************** ************ **************************/
    //추가버튼
    btnListAdd() {
      console.log('######### new row ', this.selectedDiv)
      this.closeVSnackbar()
      if (this.selectedDiv.clntId === 'COMMON') {
        this.vSnackbar(this.$t('기본데이터는 항목을 추가할 수 없습니다.'), 'warn')
        return
      }
      console.log('(오) 항목 아이템 추가 버튼', this.selectedDiv)
      // this.snackbar = true //msg 팝업
      //         this.msg = '예시항목은 수정할 수 없습니다.'
      let newRow = {
        id: this.selectedDiv.dataDiv + '_' + this.gridMain.length,
        clntId: this.getClntId(),
        compId: this.getCompId(),
        dataDiv: this.selectedDiv.dataDiv,
        safetyInspectionDailyDivItem: '',
        safetyInspectionDailyDivItemNm: '',
        seq: this.gridMain.length + 1,
        __created__: true
      }

      this.applyDataDiv = _.clone(this.selectedDiv)
      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },
    //저장버튼
    async btnListSave() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        return
      }
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()
          selectedRows.forEach((element, index) => {
            element.clntId = this.getClntId()
            element.compId = this.getCompId()
            element.dataDiv = this.selectedDiv.dataDiv
            element.delYn = 'N'
          })

          //저장 api
          this.openLoading('saving')

          // 새로운 항목 생성
          saveSafetyInspectionItemList(selectedRows.reverse(), true)
            .then(res => {
              if (res.success) {
                console.log('res', res)
              }
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.btnSearch(this.selectedDiv)
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    async btnListDelete() {
      this.closeVSnackbar()
      if (this.selectedDiv.clntId === 'COMMON') {
        this.vSnackbar(this.$t('기본데이터는 항목을 삭제할 수 없습니다.'), 'warn')
        return
      }
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warn')
        return
      }
      console.log('### 삭제할 데이터 목록', selectedRows)
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',

        current => {
          //저장 api
          this.openLoading()
          // 새로운 항목 생성
          deleteSafetyInspectionItemList(selectedRows.reverse(), true)
            .then(res => {
              if (res.success) {
                console.log('res', res)
              }
            })
            .catch(error => {})
            .finally(() => {
              this.btnSearch(this.selectedDiv)
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    dataDivNmChanged(e, item) {
      // 양식명 변경 이벤트를 받아 저장소 생성
      console.log('### e', item)
      let saveData = _.clone(item)
      saveData.__updated__ = true
      let findDataIndex = this.saveDataDivList.findIndex(el => el.dataDiv === saveData.dataDiv)
      console.log('### findDataIndex', findDataIndex)
      if (findDataIndex > -1) {
        this.saveDataDivList[findDataIndex] = saveData
      } else {
        this.saveDataDivList.push(saveData)
      }
    },
    handleItemClick(item) {
      if (this.selectedDiv === item) {
        // 같은 항목 선택 시
        return
      } else {
        // 선택된 항목의 인덱스를 저장합니다.
        this.selectedDiv = item
      }

      let params = {
        // 선택된 항목을 기반으로 필요한 데이터를 가져오기 위한 매개변수를 설정합니다.
        clntId: item.clntId,
        compId: item.compId,
        dataDiv: item.dataDiv
      }
      this.btnSearch(params)
    },
    closeBtn() {
      this.selectedDiv = {}
      // this.$emit('apply', selected)
      this.$emit('popupClose')
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////

    onEditingStart(e) {
      e.cancel = !e.data.__created__ && ['safetyInspectionDailyDivItem'].includes(e.column.dataField)
    },
    onFocusedRowChanged(e) {
      if (e.row != null) {
        this.focusedRow = e.row.data
      }
    },
    // //데이터 수정 시 로우 선택되도록
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-wrap {
  display: flex;
  gap: 8px;
  .v-btn {
    flex: 1 1 auto;
    min-width: unset;
    padding: 0 16px;
  }
}
.card-sub-title {
  color: #3e3e3f;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: normal;
}
.card-title {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: normal;
  padding: 16px 0 4px;
}
.card-title-code {
  color: #babbbb;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
